import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAiEnabled } from 'hooks/ai-firm-settings-hooks';
import { useGetApiV5FilesPendingReview } from 'api/v5/files/files';
import { ReviewModal } from './components';

export interface AIFileReviewButtonProps {
  /**
   * Old ugly dependency to refresh the list in parent component
   */
  component: any;
}

export const AIFileReviewButton: React.FC<AIFileReviewButtonProps> = ({
  component,
}) => {
  const theme = useTheme();
  const { isAiEnabled } = useAiEnabled();
  const { enableAiFileRenaming, enableAiTagging } = useFlags();
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);

  // Same gating the AI Files banner used to apply (LISD-2498): only show the
  // review count for AI-enabled firms with at least one file-AI flag on. This
  // gating previously lived in AIFlaggedBanner, and the button only rendered
  // after that banner was dismissed; the banner is now gone.
  const isEnabled = Boolean(
    isAiEnabled && (enableAiFileRenaming || enableAiTagging),
  );

  const { data: filesToReview, isLoading } = useGetApiV5FilesPendingReview(
    undefined,
    { query: { enabled: isEnabled } },
  );

  if (!isEnabled || isLoading) {
    return null;
  }

  const count = filesToReview?.count || 0;
  const noun = count === 1 ? 'file needs review' : 'files need review';
  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <button
        type="button"
        className="btn"
        style={{
          backgroundColor: '#fff',
          color: primaryColor,
          border: `1px solid ${primaryColor}`,
          marginRight: '1rem',
        }}
        onClick={() => setIsPreviewModalVisible(true)}
      >
        <strong>{count}</strong> {noun}
      </button>

      {isPreviewModalVisible && (
        <ReviewModal
          onClose={() => setIsPreviewModalVisible(false)}
          component={component}
        />
      )}
    </>
  );
};
